document.addEventListener("DOMContentLoaded", function () {
  const regionLinks = document.querySelectorAll(".region-item");

  regionLinks.forEach((link) => {
    link.addEventListener("click", function () {
      regionLinks.forEach((link) => {
        link.classList.remove("active");
      });

      this.classList.add("active");

      const name = this.getAttribute("data-territorio-nombre");
      const location = this.getAttribute("data-ubicacion");
      const territoryId = this.getAttribute("data-territorio-id");

      const description = document.getElementById(
        "territory-description-" + territoryId
      ).innerHTML;

      document.getElementById("region-title").textContent = name;
      document.getElementById("region-ubicacion").textContent = location;

      document.getElementById("region-description").innerHTML = description;
    });
  });
});
